module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-8.b71d04cc.png";